(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/start-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/start-page.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_start.react.components,
  Header = _svs$lyckoplatsen$com.Header,
  CharityContainer = _svs$lyckoplatsen$com.CharityContainer,
  Params = _svs$lyckoplatsen$com.Params;
const StartPage = () => {
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);
  return React.createElement("div", {
    className: "lp-page-start ".concat(isLoaded ? 'page-loaded' : '')
  }, React.createElement(Header, null), React.createElement(WidgetArea, {
    areaName: "startPageTopWidgetArea",
    widgetArea: "startPageTopWidgetArea"
  }), React.createElement(CharityContainer, null), React.createElement(WidgetArea, {
    className: "start-bottom-widget-area",
    areaName: "startPageBottomWidgetArea",
    widgetArea: "startPageBottomWidgetArea"
  }), React.createElement(Params, null));
};
setGlobal('svs.lyckoplatsen.components.page_start.react', {
  StartPage
});

 })(window);